import type { FloatingPosition } from '@mantine/core/lib/Floating';
import { SELECTABLE_PROPERTY_OPTIONS } from '@repo/common/components/SelectableProperty/constants';
import type { IQuestion, ISecodaEntity } from '../../api';
import type { PropertySelectorProps } from './PropertySelector';
import { PropertySelector } from './PropertySelector';

export interface QuestionStatusPropertySelectorProps
	extends Pick<PropertySelectorProps, 'onChange'> {
	entity: ISecodaEntity;
	viewerOfEntity: boolean;
	position?: FloatingPosition;
	withinPortal?: boolean;
}

export function QuestionStatusPropertySelector({
	entity,
	viewerOfEntity,
	position,
	withinPortal,
	...propertySelectorProps
}: QuestionStatusPropertySelectorProps) {
	return (
		<PropertySelector
			selected={(entity as IQuestion).status}
			type="single"
			value="status"
			iconType="tabler"
			isViewerUser={viewerOfEntity}
			readOnly={viewerOfEntity}
			options={SELECTABLE_PROPERTY_OPTIONS.status}
			position={position}
			withinPortal={withinPortal}
			{...propertySelectorProps}
		/>
	);
}
